import Model from "~/models/_Model";
import User from "./User";
import Role from "./Role";

export default class Permission extends Model {
  // Set the resource route of the model
  resource() {
    return "permissions";
  }

  relations() {
    return {
      users: User,
      roles: Role,
    };
  }

  get display_display_name() {
    return `${this.display_name} (${this.id}:${this.name})`;
  }
}
